// @flow
import * as React from "react";

import AuthService from "services/auth";

import { Navigate } from "react-router-dom";

type Props = {|
  element: React.Node,
|};

function GuestRoute({ element }: Props): React.Node {
  if (AuthService.isAuthenticated()) {
    return <Navigate to="/" replace />;
  }

  return element;
}

export default GuestRoute;
